/** @format */

import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({});

export default theme;
